module.exports = __webpack_public_path__ + "static/chaireEN-88f9dd046ca9446339d8577838677c51.png";